import { render, staticRenderFns } from "./SeoHeading.vue?vue&type=template&id=977b552c"
import script from "./SeoHeading.vue?vue&type=script&lang=js"
export * from "./SeoHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports